































import Video from '@/components/common/Video.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({
  components: {
    Swiper,
    SwiperSlide,
    Video
  }
})
export default class extends Vue {
  // 接收参数
  @Prop() public data!: object[];
  @Prop() public isMobile!: boolean;
  swiperOptionTop = {
    slidesPerView: 3,
    // loopedSlides: 8,
    loop: false,
    spaceBetween: 40,
    autoplay: 3000,
    autoplayDisableOnInteraction: false,
    // width: 600,
    // prevButton: '.swiper-button-prev-news',
    // nextButton: '.swiper-button-next-news',
    pagination: '.swiper-pagination-news',
    paginationClickable: true
  };

  @Watch('isMobile', { immediate: true })
  isMobileChange(val) {
    if (val) {
      this.swiperOptionTop.slidesPerView = 1;
    }
  }
  public handleClick(id: number) {
    this.$emit('jumpTodetail', id);
  }
  // 了解更多
  public more() {
    this.$emit('more');
  }
}
